export default __webpack_public_path__ + "static/media/258.c3c6b049.png";